// src/components/AchievementsShell.tsx
import React from 'react';

interface AchievementsShellProps {
  children: React.ReactNode; // <AchievementsView />
}

/**
 * IMPORTANT:
 * AchievementsView already provides RoddoPageShell + RoddoSectionCard layout.
 * If we wrap it again, we can end up with nested shells/cards and "blank" content.
 *
 * So this shell is intentionally minimal: it just renders children.
 */
const AchievementsShell: React.FC<AchievementsShellProps> = ({ children }) => {
  return <>{children}</>;
};

export default AchievementsShell;
